// wishlist_login------

(function () {
  const redirectUrl = '/account/login';

  function redirectLogin(event) {
    const button = event.target.closest('.wishlist-hero-list-header-login');

    if (!button) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    window.location.assign(redirectUrl);
  }

  // Capture clicks before the app's handler
  document.addEventListener('click', redirectLogin, true);

  // Also handle mousedown, which some apps use
  document.addEventListener('mousedown', function (event) {
    const button = event.target.closest('.wishlist-hero-list-header-login');

    if (!button) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    window.location.assign(redirectUrl);
  }, true);

})();






















document.addEventListener("DOMContentLoaded", function () {
  // slick slider on you-may-also-like section
  $('.you-may-also-like').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows: true,
  infinite: false,
  centerMode: false,
  focusOnSelect: true,
  vertical: false,
  verticalSwiping: false,
  prevArrow: '<div class="featured-collection-controls featured-collection-controls--prev"><button class="btn--plain prev icon feather-icon" aria-label="Previous" style=""><svg aria-hidden="true" focusable="false" role="presentation" class="icon feather-arrow-left" viewBox="0 0 24 24"><path d="M19 12H5M12 19l-7-7 7-7"></path></svg></button></div>',
  nextArrow: '<div class="featured-collection-controls featured-collection-controls--next"><button class="btn--plain next icon feather-icon" aria-label="Previous" style=""><svg aria-hidden="true" focusable="false" role="presentation" class="icon feather-arrow-right" viewBox="0 0 24 24"><path d="M5 12h14M12 5l7 7-7 7"></path></svg></button></div>',
  responsive: [
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 3,
        infinite: true,
        arrows: false,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1.5,
      }
    }
  ]
  });
});

function fillAltTitle() {
  const body = document.body;
  let contentPick = body.getAttribute('content_pick');

  // Trim & fallback
  contentPick = contentPick && contentPick.trim() !== ''
    ? contentPick.trim()
    : 'Lego';

  document.querySelectorAll('img').forEach(img => {
    // ALT
    if (!img.hasAttribute('alt') || img.getAttribute('alt').trim() === '') {
      img.setAttribute('alt', 'Lego');
    }

    // TITLE
    if (!img.hasAttribute('title') || img.getAttribute('title').trim() === '') {
      img.setAttribute('title', contentPick);
    }
  });
}



setTimeout(() => {
  // Initial run
  fillAltTitle();

  // For lazyloaded / dynamically added images
  const observer = new MutationObserver(() => {
    fillAltTitle();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['alt', 'title', 'src', 'srcset']
  });
}, 2000);
